import { Children, cloneElement } from 'react';

import {
  useApplicationsGetQueryById,
  useApplicationsPutQueryById,
  useApplicationsReopenQueryById,
} from '../../../Common/Queries/applicationsQueries';
import { usePositionsGetQueryById } from '../../../Common/Queries/positionsQueries';
import { useTemplatesGetQueryByIds } from '../../../Common/Queries/templateQueries';

export function ApplicationDetailContainer({ children, id, props }) {
  const applicant = useApplicationsGetQueryById(id, {});
  const putToApplication = useApplicationsPutQueryById();
  const reopenApplication = useApplicationsReopenQueryById();

  const positionResponse = usePositionsGetQueryById(
    {
      reqId: applicant?.data?.position?.id,
    },
    {
      enabled: !!applicant?.data?.position?.id, // wait until application is fetched
    }
  );

  const olTemplateIDs = positionResponse?.data?.templateID || [];

  const olTemplatesResponse = useTemplatesGetQueryByIds(olTemplateIDs, {
    enabled: !!positionResponse?.data?.templateID,
  });

  return Children.only(
    cloneElement(children, {
      applicant,
      putToApplication,
      reopenApplication,
      olTemplates: olTemplatesResponse.length > 0 ? olTemplatesResponse.map((res) => res.data) : [],
      olTemplatesResponse,
      olTemplateIDs,
      id,
      ...props,
    })
  );
}
